import { render } from "./FragrancesAttributesSecondForm.vue?vue&type=template&id=3c1c945e&scoped=true"
import script from "./FragrancesAttributesSecondForm.vue?vue&type=script&lang=js"
export * from "./FragrancesAttributesSecondForm.vue?vue&type=script&lang=js"

import "./FragrancesAttributesSecondForm.vue?vue&type=style&index=0&id=3c1c945e&lang=scss&scoped=true"
import "./FragrancesAttributesSecondForm.vue?vue&type=style&index=1&id=3c1c945e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c1c945e"]])

export default __exports__